import { useState, useEffect } from 'react'
import * as XLSX from 'xlsx';
import { read, utils, writeFileXLSX } from 'xlsx';
import {  toast } from 'react-toastify';
import {checkExpenseFormat, checkDuplication, checkFormat, formatBytes, removeSuffix} from '../assets/FileCheck';
import {Link} from 'react-router-dom';
import {Form,Button } from 'react-bootstrap';
import {BiFile, BiCog} from "react-icons/bi";
import Pool from "./UserPool";
import Tnedata from "../services/data";

const UploadCsv = ({toggle, logdata})=> {
    const [file, setFile] = useState();
    const [filedata, setFileData] = useState();
    const [col ,setCol]= useState();
    const [status, setStatus] = useState("Upload");
    const [isLoading, setIsLoading] = useState(false);
    //Button Enable and Disable
    const [isenable,setIsnable] = useState(true);
    const [iserror,setIserror] = useState(0);
    const [data, setData] = useState([]);
    const [metalog, setMetalog] = useState([]);
    const [error, setError] = useState(null);

    const[err, setErr] = useState();

    //const user = Pool.getCurrentUser();
    const user = sessionStorage.getItem("user")

    //old Template column
    //const [preformat,setPreformat] = useState(['Org Unit 1 - Code', 'Document Header Text/Report ID', 'Report Key','Employee', 'Employee ID', 'Country (of Employee)', 'Report Name','Personal', 'Parent Expense Type', 'Expense Type','Entry Expense Amount (reimbursement currency)','Reimbursement Currency', 'Expense Amount (rpt)', 'Reporting Currency','Total Report Amount', 'Reimbursement Currency.1','Total Report Amount (rpt)', 'Reporting Currency.1','Total Approved Amount (rpt)', 'Reporting Currency.2','Default Approver', 'Sent for Payment Date', 'First Submitted Date']);
    //New Template Column
    //const [preformat,setPreformat] = useState(['Org Unit 1 - Code','Document Header Text/Report ID','Report Key','Employee','Employee ID','Country (of Employee)','Report Name','Personal','Parent Expense Type','Transaction Date','Expense Type','Entry Expense Amount (reimbursement currency)','Approved Amount','Reimbursement Currency','Expense Amount (rpt)','Reporting Currency','Total Report Amount','Reimbursement Currency.1','Total Report Amount (rpt)','Reporting Currency.1','Total Approved Amount (rpt)','Reporting Currency.2',	'Default Approver','Sent for Payment Date','Approval Status','Processor Start Date'])
    const [preformat,setPreformat] = useState(['Org Unit 1 - Code', 'Document Header Text/Report ID', 'Report Key', 'Employee', 'Employee ID', 'Country (of Employee)', 'Report Name', 'Personal', 'Parent Expense Type', 'Transaction Date', 'Expense Type', 'Entry Expense Amount (reimbursement currency)', 'Approved Amount', 'Reimbursement Currency', 'Expense Amount (rpt)', 'Reporting Currency', 'Total Report Amount', 'Reimbursement Currency.1', 'Total Report Amount (rpt)', 'Reporting Currency.1', 'Total Approved Amount (rpt)', 'Reporting Currency.2', 'Default Approver', 'Sent for Payment Date', 'Approval Status', 'Processor Start Date'])
   
    //console.log(preformat)
    const handleError = (error) => {
      setIserror(0);
      // Handle the error here
      console.error("Error caught in OtherPage component:", error);
      // Check if error is not null and not undefined
      if (error !== null && error !== undefined) {
        const errorLength = error.length; // Assuming error is an array or a string
        setIserror(errorLength);
        //console.log("Receiving error length:", errorLength);
        // Determine whether to enable or disable based on error length
        setIsnable(true);
      } else {
        setIserror(0); // Set error length to 0 when there's no error
        setIsnable(false); // Disable when there's no error
      }
    };

//Data Upload Function
  const postcsvandlog= async () => {
    //console.log(filedata);
    const ctimestamp = Date.now(); 
    const currDate = new Date().toLocaleDateString("fr-CA");
    const currTime = new Date().toLocaleTimeString('en-GB', { hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit'});
    const datetime = currDate+" "+ currTime;
    const currdatetime = new Intl.DateTimeFormat('en-IN', {year: 'numeric', month: '2-digit',day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'}).format(ctimestamp);
    const currentTime = new Date().toLocaleTimeString('en-GB', { hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit'});
    const currentdatetime = currdatetime+" "+ currentTime;
    const filedate= file? file.lastModified : ''
    const fileDate = new Date(filedate).toLocaleDateString("fr-CA", );                                
    const fileTime = new Date(filedate).toLocaleTimeString('en-GB', { hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit'});
    const filedatetime = fileDate+" "+ fileTime;
    const csvfileinfo = [{"filename":file.name, "filesize":formatBytes(file.size), "nooflines": filedata.length, "user":user, "timestamp":filedatetime, "create_at":datetime, "file_type":"expense"  }] ;
    //console.log(csvfileinfo);
    const cname = logdata.find(item => item.filename === file.name && item.filesize === formatBytes(file.size));
    //console.log(csvfileinfo)
    if (logdata.length === 0){
      try {
      toast("Data uploading...");
      setStatus("LOADING...")
      const response1 = await Tnedata.upload_tne_expense(filedata);
      setStatus("Expense In Progress")
      //console.log("")
      await Tnedata.compute_expense_audits();
      //await handlePostRequest()
      if(response1.data.message === "Expense Data inserted successfully"){
      toast("log uploading...");
      const response = await Tnedata.postLog(csvfileinfo);
      setStatus("UPLOAD COMPLETED")
      toast("Upload Completed...");

      }
      ////console.log(cdata)
      //console.log(filedata);
      //console.log(response);
      //console.log(response1);
    } catch (error) {
      console.error('Error: ' + error)
      setError('Error occurred please contact Administrator' );
    }
    }else{
        if(cname){
          toast("Excel File Already Exits");
          setStatus("UPLOAD")
          setIserror(1)
        }else{
          try {
          setIserror(0)
          toast("Data uploading...");
          setStatus("LOADING...")
         // await postexpensejson(filedata);
          const response1 = await Tnedata.upload_tne_expense(filedata); 
          setStatus("Expense In Progress")
          await Tnedata.compute_expense_audits();
          //await handlePostRequest()
          //console.log(response1.data.message)
          if(response1.data.message === "Expense Data inserted successfully"){
          const response = await Tnedata.postLog(csvfileinfo);
          setStatus("UPLOAD COMPLETED")
          toast("Upload Completed...");
          }
          //console.log(response);
        } catch (error) {
          console.error('Error: ' + error)
          setError('Error occurred please contact Administrator' );
        }
        }
      }
    };

    useEffect(() => {
      const filteredData = logdata.filter(item => item.file_type === 'expense');
      const recentlog = filteredData[0];
      setMetalog(filteredData)
    }, []);

    //console.log(metalog);

    const readUploadFile = async(e) => {
      e.preventDefault();
      setIserror(0)
      setStatus("Upload")
      toast("Data Checking...");
      setIsLoading(true)
      setFile(e.target.files[0]);

      const file = e.target.files[0];
      //console.log(file.size)
      // Check if the file size is below 10MB
      if (file.size > 10 * 1024 * 1024) { // 10MB in bytes
        toast.error("File size exceeds the maximum limit of 10MB.");
        setIsLoading(false);
        return;
        }

      if (e.target.files) {
          const reader = new FileReader();
          reader.onload = async(e) => {
              const data = e.target.result;
              const workbook = XLSX.read(data,{ type: "array" });
              const wsname = workbook.SheetNames[0];
              const ws = workbook.Sheets[wsname];
             // console.log(ws)
              //const sheetName = workbook.SheetNames[0];
             // const worksheet = workbook.Sheets[sheetName];
              const json = XLSX.utils.sheet_to_json(ws, {
                raw: false, // Include formatted text (dates, numbers) instead of plain values
                dateNF: 'yyyy-mm-dd', // Date format to use when formatting dates,
                defval:""
              });

             //console.log(json)
             // XLSX.utils.sheet_to_json(worksheet);
             //console.log(Object.keys(json[0]))
              const jsoncol = Object.keys(json[0]);
            // console.log(jsoncol)
             // console.log("preferred format", preformat)
              // await checkExpensecolLess(jsoncol, preformat, handleError);
               //await checkExpensecolMore(jsoncol, preformat, handleError);
               //console.log("jsoncol.length", jsoncol)
             // console.log("preformat.length", preformat.length)

            if (jsoncol.length > 0 ) {
                jsoncol[17] = "Reimbursement Currency.1";
                jsoncol[19] = "Reporting Currency.1";
                jsoncol[21] = "Reporting Currency.2";
            } else {
                console.error("Index out of range");
            }
            const modifiedJson = json.map(item => {
              const modifiedItem = { ...item };
              const keys = Object.keys(item);
              if (keys.length >= 17) {
                  modifiedItem['Reimbursement Currency.1'] = modifiedItem[keys[17]];
                 // delete modifiedItem[keys[17]];
              }
              if (keys.length >= 20) {
                  modifiedItem['Reporting Currency.1'] = modifiedItem[keys[19]];
                 // delete modifiedItem[keys[19]];
              }
              if (keys.length >= 22) {
                modifiedItem['Reporting Currency.2'] = modifiedItem[keys[21]];
                //delete modifiedItem[keys[21]];
            }
              return modifiedItem;
          });
          const jsoncol2 = Object.keys(modifiedJson[0]);
          setCol(jsoncol2);
         // console.log(modifiedJson)

          // const modifiedObject = [];
          // for (const key in jsoncol2) {
          //   if (jsoncol2.hasOwnProperty(key)) {
          //     modifiedObject[key] = removeSuffix(jsoncol2[key]);
          //   }
          // }

          //console.log(jsoncol)
          //console.log(jsoncol2)
             await checkDuplication(jsoncol2, preformat, handleError);
              //await checkExpenseFormat(jsoncol2, preformat, handleError);
              await checkFormat(jsoncol2, preformat, handleError);
             // console.log(modifiedJson)
               setFileData(modifiedJson);
          };
          reader.readAsArrayBuffer(e.target.files[0]);
      }
      setIsLoading(false)
  }


const datalength = iserror ? iserror.length  : 0 ;
  //Import Button Function
  const handleOnSubmit = async (e) => {
    e.preventDefault();
    await postcsvandlog();
  };

  const downloadExcel = () => {
    // Replace 'path_to_your_excel_file' with the actual path to your Excel file
    const excelFilePath = '/data_template/Expense_Data_Template.xlsx';
    window.open(excelFilePath);
  };

//console.log(logdata);
  return (
    <>
<form>

    <input type="file" name="upload" id="upload" onChange={readUploadFile} /> 
    <div className='text-center mt-1'>
        <Button variant="primary" type="submit" onClick={handleOnSubmit}  disabled={ iserror > 0 ? true  : false}  className='download'>  {status} </Button>     
        <Button onClick={(e) => {e.preventDefault(); window.open('location', '_self', ''); window.close(); }} className='btn mx-2 btn-primary download'>Exit</Button> 
        <div>
        {isLoading ? "Please wait ...." : " " }
          <p>{err}</p>
          {error && <p style={{color:"red"}}>Error: {error}</p>}
        {logdata.length === 0 ? "" :  <><div className="text-left" style={{fontSize:"13px", lineHeight:"30px"}}><><h6 className='mt-2'>Recent log</h6> <div  ><div style={{width:"100%"}} className="text-left" ><BiFile/>  {logdata.length === 0  ? "" : logdata[0].filename}  </div> <div style={{width:"100%"}}><BiCog/>  {logdata.length === 0   ? "" : logdata[0].filesize}</div></div> </></div> </> }
    </div>
</div>
</form>
<div className={toggle ? "isexpanded": "ishide"}>
<hr/>
   <div className='row'>
    <div className='col text-start'>
        <p className='text-center'>
        <button onClick={downloadExcel} className='btn btn-primary download'>Expense Template Download</button>
        </p>
        <ul>
            <li>The data should be in the attached format.</li>
            <li>The data should be in xlsx format.</li>
            <li>Before uploading new data, auditing of existing data should be completed.</li>
        </ul>
    </div>
   </div>
 </div>
    </>
  )
}
export default UploadCsv;